import Big from 'big.js';
import {numUtil} from './num';

export const spotOrderUtil = {
  isConditionalOrder(order) {
    return ['Stop', 'StopLimit', 'LimitIfTouched', 'MarketIfTouched'].indexOf(order.ordType) > -1;
  },
  isMarketOrder(order) {
    return ['Market', 'Stop', 'MarketIfTouched'].indexOf(order.ordType) > -1;
  },
  isLiqTradeOrder(order) {
    return 'LiqTrade' === order.ordType;
  },
  calcValue({qtyType, priceEp, baseQtyEv, quoteQtyEv, baseQtyScale, quoteQtyScale, baseQtyPrecision, quoteQtyPrecision}) {
    const precision = this.getByQtyType(qtyType, baseQtyPrecision, quoteQtyPrecision, true);
    if (priceEp <= 0) {
      return this.formatDelimit(0, precision);
    }
    const price = Big(priceEp).div(Big(10).pow(quoteQtyScale));
    if (qtyType === 'ByBase') {
      const baseQtyFactor = Big(10).pow(baseQtyScale);
      return this.formatDelimit(Big(baseQtyEv).div(baseQtyFactor).times(price), precision);
    }
    if (qtyType === 'ByQuote') {
      const quoteQtyFactor = Big(10).pow(quoteQtyScale);
      return this.formatDelimit(Big(quoteQtyEv).div(quoteQtyFactor).div(price), precision);
    }
    return this.formatDelimit(0, precision);
  },
  calcValueWU({qtyType, priceEp, baseQtyEv, quoteQtyEv, baseQtyScale, quoteQtyScale, baseQtyPrecision, quoteQtyPrecision, displayBaseCurrency, quoteCurrency}) {
    const value = this.calcValue({qtyType, priceEp, baseQtyEv, quoteQtyEv, baseQtyScale, quoteQtyScale, baseQtyPrecision, quoteQtyPrecision});
    if (qtyType === 'ByBase') {
      return [value, quoteCurrency].join(' ');
    }
    if (qtyType === 'ByQuote') {
      return [value, displayBaseCurrency].join(' ');
    }
    return '-';
  },
  calcQty(qtyType, baseQty, quoteQty) {
    if (qtyType === 'ByBase') {
      return numUtil.delimit(baseQty);
    }
    if (qtyType === 'ByQuote') {
      return numUtil.delimit(quoteQty);
    }
    return '';
  },
  calcQtyWU(qtyType, baseQty, baseCurrency, quoteQty, quoteCurrency) {
    if (qtyType === 'ByBase') {
      return numUtil.delimit(baseQty) + ' ' + baseCurrency;
    }
    if (qtyType === 'ByQuote') {
      return numUtil.delimit(quoteQty) + ' ' + quoteCurrency;
    }
    return '';
  },
  getByQtyType(qtyType, base, quote, inverse = false) {
    if (qtyType === 'ByBase') {
      return inverse ? quote : base;
    }
    if (qtyType === 'ByQuote') {
      return inverse ? base : quote;
    }
  },
  joinWU(value, currency) {
    if (!value || !currency) {
      return '-';
    }
    return [value, currency].join(' ');
  },
  formatDelimit(value, precision) {
    return numUtil.delimit(numUtil.floor(value, precision));
  },
  isFinalOrder(ordStatus) {
    return ['Deactivated', 'Filled', 'Canceled', 'Rejected'].indexOf(ordStatus) > -1;
  },
};
